export interface EventListen {
  event?: string;
  type?: string;
  application?: string;
  callback: Function;
}

export interface EventResponse {
  action: string;
  payload: boolean;
}
export enum NameApplication {
  NAME = 'CH_FORM',
}

export enum Events {
  NAME = 'REDUX',
}

export enum Types {
  NAME = 'INITIAL_STATE',
}
